import { render } from "./TableCaption.vue?vue&type=template&id=20f35eef&ts=true"
import script from "./TableCaption.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableCaption.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/table/TableCaption.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20f35eef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20f35eef', __exports__)) {
    api.reload('20f35eef', __exports__)
  }
  
  module.hot.accept("./TableCaption.vue?vue&type=template&id=20f35eef&ts=true", () => {
    api.rerender('20f35eef', render)
  })

}


export default __exports__